import React, { Fragment, useEffect, useState } from "react";
import { Collapse, Button, Input, Col, Row } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import style from "./styles/ExtendedDataTab.scss";
import { showToast } from "../../../../utils/Helper";
import { DateField, FormField } from "../../../../utils";
import ReactDatePicker from "react-datepicker";

const ExtendedDataTab = ({ person, services, role, onboarding ,setPersonData, userSession, refresh, newOnboardingVersion = false,}) => {
  const [itemGroups, setitemGroups] = useState(null);
  const [sending, setSending] = useState(false);

  const saveExtendedData = () => {
    setSending(true);
    let itemGroupsWithInstancesFiltered = itemGroups.map((itemGroup) => {
      if (itemGroup.Instance) {
        let filteredInstances = itemGroup.Instance.filter((instance) => {
          return instance.ExtensionInstanceText != "" || instance.ExtensionItemId != 0;
        });
        itemGroup.Instance = filteredInstances;
      }

      return itemGroup;
    });
    let payload = {
      personId: person.PersonId,
      extendedData: itemGroupsWithInstancesFiltered,
    };
    try {
      if (!onboarding) {
        const updatedBody = {
          ...payload, 
          isSystemUser: newOnboardingVersion ? true : false,
        };
        services.updatePersonExtendedData(updatedBody, (response) => {
          setSending(false)
          if (response.result.Code == 200) {
            showToast(response.result.Description);
            refresh() 
          } else {
            showToast(response.result.Description);
          }
        });
      } else {
        const postPerson = {
          ...person,
          PersonExtendedData: itemGroupsWithInstancesFiltered,
        };
        const body = {
          postPerson: postPerson,
          OnboardingId: onboarding,
        };
        services.fetchNewPerson(body, (response) => {
          setSending(false);
          setPersonData(postPerson);
          showToast("Your changes have been saved.");
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (services) {
      try {
        if (!onboarding) {
          services.fetchPersonExtendedData({ personId: person.PersonId }, (response) => {
            setitemGroups(response.extendedData);
          });
        } else {
          if (person.PersonExtendedData && person.PersonExtendedData.length > 0){
            setitemGroups(person.PersonExtendedData);
          }else{
            services.fetchPersonExtendedData({ personId: person.PersonId }, (response) => {
              setitemGroups(response.extendedData);
            });
          }
          
        }
      } catch (e) {}
    }
  }, [services]);

  const modifyItemGroup = (itemgroup) => {
    let newItemGroups = itemGroups.map((item, i) => {
      if (item.ExtensionGroupId == itemgroup.ExtensionGroupId) {
        return itemgroup;
      } else {
        return item;
      }
    });
    setitemGroups(newItemGroups);
  };

  return (
    <div>
      <div>
        {itemGroups &&
          itemGroups.map((item, index) => (
            <ExtendedDataItem data={item} key={item.ExtensionGroupId} modifyItemGroup={modifyItemGroup} userSession={userSession} />
          ))}
      </div>
      <br />

      {userSession.IsReadOnly === false && <LaddaButton
        className="btn btn-ladda btn-primary"
        loading={sending}
        onClick={() => saveExtendedData()}
        data-style={EXPAND_RIGHT}
      >
        {sending ? " Saving" : " Save"}
      </LaddaButton>}
    </div>
  );
};

const ExtendedDataItem = ({ data, modifyItemGroup, userSession }) => {
  const [collapse, setCollapse] = useState(false);
  const [itemgroup, setItemGroup] = useState(data);
  const [isMultipleSelection, setIsMultipleSelection] = useState(itemgroup.ExtensionGroupMultipleSelection);
  const [locked, setLocked] = useState(true);

  useEffect(() => {
    !itemgroup.Instance || itemgroup.Instance.length == 0
      ? setItemGroup({
          ...itemgroup,
          Instance: [defaultInstance],
        })
      : "";
  }, [itemgroup.Instance]);

  const defaultInstance = {
    ExtensionInstanceId: 0,
    ExtensionGroupId: data.ExtensionGroupId,
    ExtensionRefId: 0,
    ExtensionItemId: 0,
    ExtensionInstanceText: "",
    ExtensionInstanceDate:  new Date().toDatetimeLocal(),
  };

  useEffect(() => {
    modifyItemGroup(itemgroup);
  }, [itemgroup]);

  const handleRemoveClick = (index) => {
    let newInstances = [...itemgroup.Instance];
    newInstances.splice(index, 1);
    setItemGroup({ ...itemgroup, Instance: newInstances });
  };

  const handleAddClick = () => {
    setItemGroup({
      ...itemgroup,
      Instance: [
        ...itemgroup.Instance,
        {
          ExtensionInstanceId: 0,
          ExtensionGroupId: data.ExtensionGroupId,
          ExtensionRefId: 0,
          ExtensionItemId: 0,
          ExtensionInstanceDate:  new Date().toDatetimeLocal(),
          ExtensionInstanceText: "",
        },
      ],
    });
  };

  const modifyInstance = (index, field, value) => {
    let newInstances = [...itemgroup.Instance];
    if (field == "ExtensionInstanceDate") {
      newInstances[index].ExtensionInstanceDate = value;
    } else {
      if (data.ExtensionGroupType == "freetext") {
        newInstances[index].ExtensionInstanceText = value;
      } else {
        newInstances[index].ExtensionItemId = value;
      }
    }
    setItemGroup({ ...itemgroup, Instance: newInstances });
  };

  return (
    <div className={style.itemgroup}>
      <Button
        color="link"
        className={style.titleButton}
        onClick={() => {
          setCollapse(!collapse);
        }}
      >
        <b>{data.ExtensionGroupInternal}</b>
      </Button>{" "}
      {userSession.IsReadOnly === false && collapse && (
      locked ? (
        <Button color="link" className={style.lockButton} onClick={() => setLocked(!locked)}>
          <i class="fa fa-lock"></i>
        </Button>
      ) : (
        <Button color="link" className={style.lockButton} onClick={() => setLocked(!locked)}>
          <i class="fa fa-unlock"></i>
        </Button>
      )
      )}
      <Collapse isOpen={collapse}>
        {itemgroup.Instance
          ? itemgroup.Instance.map((x, i) => {
              return (
                <div>
                  <ExtendedDataItemInstance
                    data={x}
                    i={i}
                    type={data.ExtensionGroupType}
                    items={data.Item ? data.Item : []}
                    internalName={data.ExtensionGroupInternal}
                    Instance={itemgroup.Instance}
                    readOnly={locked}
                    modifyInstance={modifyInstance}
                    isMultipleSelection={isMultipleSelection}
                    handleAddClick={handleAddClick}
                    handleRemoveClick={handleRemoveClick}
                    userSession={userSession}
                  />
                </div>
              );
            })
          : ""}
      </Collapse>
    </div>
  );
};

const ExtendedDataItemInstance = ({
  data,
  internalName,
  i,
  Instance,
  type,
  items,
  modifyInstance,
  isMultipleSelection,
  handleAddClick,
  handleRemoveClick,
  readOnly,
  userSession
}) => {
  return (
    <div className={style.iteminstance}>
      <Fragment>
        <Row className={style.row}>
          <Col xs={12} sm={5} lg={4} style={{ marginTop: "10px" }}>
            {type == "freetext" && (
              <Input
                name="ExtensionInstanceText"
                placeholder={internalName}
                value={
                  internalName === "ExportedToInterop" && !data.ExtensionInstanceText
                    ? "Not exported"
                    : data.ExtensionInstanceText
                }
                onChange={(e) => modifyInstance(i, "ExtensionInstanceText", e.target.value)}
                readOnly={readOnly}
              />
            )}
            {type == "enumerated" && (
              <Input
                type="select"
                name="ExtensionItemId"
                value={data.ExtensionItemId}
                onChange={(e) => modifyInstance(i, "ExtensionItemId", e.target.value)}
                readOnly={readOnly}
              >
                <option value="">Select</option>
                {items.map((value, index) => (
                  <option key={value.ExtensionItemId} value={value.ExtensionItemId}>
                    {value.ExtensionItemDescription}
                  </option>
                ))}
              </Input>
            )}
          </Col>
          <Col xs={12} sm={5} lg={2} style={{ marginTop: "10px" }}>
            <Input
              label=""
              type="datetime-local"
              value={data.ExtensionInstanceDate ? data.ExtensionInstanceDate : new Date().toDatetimeLocal()}
              name="ExtensionInstanceDate"
              onChange={(e) => modifyInstance(i, "ExtensionInstanceDate", e.target.value)}
              readOnly={true}
            />
          </Col>
          <Col xs={Instance.length - 1 !== i ? 12 : 6} sm={1} lg={1} className={style.colButton}>
            <div className="btn-box">
              {Instance.length !== 1 && data.ExtensionInstanceId == 0 && isMultipleSelection && (
                <Button
                  onClick={() => handleRemoveClick(i)}
                  color="danger"
                  className={style.butttonX}
                  disabled={readOnly}
                >
                  x
                </Button>
              )}
            </div>
          </Col>
          <Col
            xs={Instance.length !== 1 && data.ExtensionInstanceId == 0 ? 12 : 6}
            sm={1}
            lg={1}
            className={style.colButton}
          >
            {userSession.IsReadOnly === false && Instance.length - 1 === i && isMultipleSelection && (
              <Button
                onClick={handleAddClick}
                color="success"
                className={style.butttonAdd}
                disabled={readOnly}
              >
                +
              </Button>
            )}
          </Col>
        </Row>
      </Fragment>
    </div>
  );
};

export default ExtendedDataTab;
